import React from 'react';

function humanise(value) {
  if (value === undefined || value === null || value === '') return 'Not provided';
  return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value);
}

export default function WizardReviewBlock({ step, fields, values, onEdit, renderValue }) {
  return (
    <section className="wizard-review-block">
      <header className="wizard-review-header">
        <h3>{step.title}</h3>
        <button type="button" onClick={onEdit}>Edit</button>
      </header>
      <dl className="wizard-review-body">
        {(step.fields || []).map((fieldId) => {
          const custom = renderValue ? renderValue(fieldId) : null;
          if (custom === false) return null;
          if (custom) return custom;
          const config = fields[fieldId] || {};
          return (
            <div className="wizard-review-row" key={fieldId}>
              <dt>{config.label || fieldId}</dt>
              <dd>{humanise(values[fieldId])}</dd>
            </div>
          );
        })}
      </dl>
    </section>
  );
}
